import { NO_TOPIC, TopicChoice } from '../comuni-helper';
import { COMUNI_TOPICS, ComuniTopic } from '../constants';

/**
 * A template's topic travels in its name: `<topic>__<name>`, e.g. `idrico__sospensione_idrica_programmata`.
 * Providers (Gupshup, SMS, Mailtrap) have no field for it, and the name is what every template listing
 * returns. A name without a known prefix belongs to "My templates" (NO_TOPIC).
 *
 * `__` keeps the prefix valid in a WhatsApp template name (`^[a-z][a-z0-9_]*$`); connectors may append
 * their own suffixes (the WhatsApp header image id), which the prefix does not care about.
 */
export const TOPIC_SEPARATOR = '__';

export const topicOfTemplateName = (name: string): ComuniTopic | null => {
  const separatorAt = name.indexOf(TOPIC_SEPARATOR);
  if (separatorAt <= 0) return null;
  const candidate = name.slice(0, separatorAt);
  return (COMUNI_TOPICS as readonly string[]).includes(candidate) ? (candidate as ComuniTopic) : null;
};

export const stripTopicPrefix = (name: string): string => {
  const topic = topicOfTemplateName(name);
  return topic ? name.slice(topic.length + TOPIC_SEPARATOR.length) : name;
};

/** Idempotent: a name that already carries a prefix (the Customize prefill) gets the new one, not two. */
export const withTopicPrefix = (topic: ComuniTopic, name: string): string =>
  `${topic}${TOPIC_SEPARATOR}${stripTopicPrefix(name)}`;

/** The Template step filter: a topic shows its own templates, NO_TOPIC ("My templates") the unprefixed ones. */
export const belongsToTopic = (name: string, choice: TopicChoice): boolean =>
  choice === NO_TOPIC ? topicOfTemplateName(name) === null : topicOfTemplateName(name) === choice;
